export default defineNuxtPlugin(() => {
  if (process.client && typeof window.fbq === 'undefined') {
    ;(window as any).fbq = function () {
      console.warn('Facebook Pixel is not configured.')
    }
  }
})
